import React from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import { PageHeading, useAuth } from "../../components";
import RequestCreateAlert from "../requests/components/RequestCreateAlert";
import HomePlannedInterventionsContent from "./components/interventions/HomePlannedInterventionsContent";
import HomeCompletedInterventionsContent from "./components/interventions/HomeCompletedInterventionsContent";
import HomeDocumentsContent from "./components/documents/HomeDocumentsContent";
import HomeServiceObjectsUpcomingRevisionsContent from "./components/serviceObjects/HomeServiceObjectsUpcomingRevisionsContent";

const HomePage: React.FC = (): React.ReactElement => {
  const { user } = useAuth();

  const { tCommon, tRequest } = useCustomTranslation();

  return (
    <ContentWrapper htmlTitle={tCommon("menu_home")}>
      <PageHeading
        title={tCommon("customer_portal_company", {
          companyName: user?.companyName,
        })}
        className="mb-2"
      />
      <HomeDocumentsContent />
      <HomePlannedInterventionsContent />
      <HomeCompletedInterventionsContent />
      <HomeServiceObjectsUpcomingRevisionsContent />
      <RequestCreateAlert
        title={tRequest("cp_home_title")}
        description={tRequest("cp_home_description")}
      />
    </ContentWrapper>
  );
};

export default HomePage;
